import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  itemIds: string[];
  toSectionId: string;
  createReferences: boolean;
  position?: string;
  insertIndex?: number;
};

const [useDuplicateItems, duplicateItems] = createAsyncAction(
  "items/duplicate",
  async ({ toSectionId, itemIds, createReferences, position, insertIndex: _insertIndex }: Args) => {
    return await API.call<{ items: string[] }>({
      endpoint: "items/duplicate",
      method: "PUT",
      data: {
        uuids: itemIds,
        section_uuid: toSectionId,
        create_references: createReferences,
        ...(position && { position }),
      },
    });
  }
);
export default useDuplicateItems;
export { duplicateItems };
